import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Loader2, Truck } from "lucide-react";

// Native-camera deep-link target for a scanned donor/truck QR (…/scan/donor/<token>).
// Resolves the token to the truck and forwards to its record — mirrors ScanPartPage.
export default function ScanDonorPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/scan/resolve", { params: { code: token } })
      .then(({ data }) => navigate(data.url, { replace: true }))
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail)));
  }, [token, navigate]);

  return (
    <div className="max-w-lg mx-auto" data-testid="scan-donor-page">
      <Link to="/donors" className="font-mono text-xs text-[#B01E28] underline">← trucks &amp; equipment</Link>
      <h1 className="font-display text-2xl font-bold tracking-tight mt-3">Scanned truck tag</h1>
      <p className="text-xs text-slate-500 font-mono mb-4 break-all">token: {token}</p>
      {error ? (
        <div className="border border-destructive text-destructive p-4 text-sm" data-testid="scan-donor-error">{error}</div>
      ) : (
        <div className="flex items-center gap-2 text-slate-500 text-sm" data-testid="scan-donor-loading">
          <Loader2 className="w-4 h-4 animate-spin" /><Truck className="w-4 h-4" /> Opening truck record…
        </div>
      )}
    </div>
  );
}
